import { useParams } from 'react-router-dom';
import { EstimateView } from '../Estimate/Estimate';
import { useAdminSession } from './adminSession';

// 관리자용 견적서 출력 (/admin/orders/:id/estimate) — 관리자 토큰으로 조회한다
function AdminEstimate() {
  const { id } = useParams<{ id: string }>();
  const [session] = useAdminSession();

  if (!id) return null;
  return (
    <EstimateView
      orderId={id}
      token={session?.token ?? null}
      backTo={`/admin/orders/${id}`}
      backLabel="주문 상세로"
    />
  );
}

export default AdminEstimate;
